/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

interface LinkCardArgs {
  routeName: string;
  routeQuery?: Record<string, string | null>;
  dynamicSegment: string;
  external?: boolean;
  onClick?: () => unknown;
  disabled?: boolean;
}

export default class LinkCard extends Component<LinkCardArgs> {
  @action
  onClick() {
    if (this.args.onClick) {
      this.args.onClick();
    }
  }
}
